module.exports = __webpack_public_path__ + "static/om-b6771181ffa23699d31f5087041547ba.svg";